/* eslint-disable import/prefer-default-export */
export const categoryColors = {
  "Self Care": { backgroundColor: "#F7A79A", color: "#374B5B" },
  Community: { backgroundColor: "#548231", color: "white" },
  Culture: { backgroundColor: "#007EA3", color: "white" },
  Eats: { backgroundColor: "#D9B302", color: "#374B5B" },
};
